import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';

const SavedResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 18px;
  padding: 12px 16px 12px 16px;
  background-color: var(--brand-base-0);
  color: var(--brand-base);

    @media screen and (min-width: 320px) and (max-width: 1699px) {
      flex-direction: column;
  }
`;

const SavedResultsExcessWrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;

    @media screen and (min-width: 320px) and (max-width: 767px) {
      align-items: flex-start;
    }
`;

const SavedResultsButtonWrapper = styled.div`
  display: flex;
  width: 20rem;
  text-align: center;
  justify-content: center;
  align-items: center;

  a {
    font-size: 14px;
    font-weight: 600;
    color: var(--brand-primary);
    padding: 14px 24px;
    background: var(--brand-base-0);
    border: 1px solid var(--brand-primary);
    box-sizing: border-box;
    box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;

const InfoIcon = styled(FontAwesomeIcon)`
  color: var(--brand-primary);
  line-height: 20px;
  height: 2rem;
  margin-right: 1.5rem;
`;

const SavedResultsMessage = (props) => {
    const { renderUpdatesQuoteModal } = props;

    return (
        <SavedResultsContainer>
            <SavedResultsExcessWrapper>
                <InfoIcon icon={faInfoCircle} />
                <p>
                    The quotes and product information were accurate at the time you originally quoted and are subject to change.
                    You should consider whether the product is suitable for you and read the PDS before purchasing.
                </p>
            </SavedResultsExcessWrapper>
            <SavedResultsButtonWrapper>
                {renderUpdatesQuoteModal()}
            </SavedResultsButtonWrapper>
        </SavedResultsContainer>
    );
};

SavedResultsMessage.propTypes = {
    renderUpdatesQuoteModal: PropTypes.func
};

export default SavedResultsMessage;
